<template>
    <div>
        <el-row>
            <el-col >
                <img src="@/assets/images/bottom.jpg" alt="底部" style="display: block;margin:0 auto;width:100%">
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default{
    name:'Bottom',
    data () {
        return {
            data:[
                {'name':'郭女士','email':'guoliqi@iceo.com.cn','tel':'010-59512950'},
               
            ]
        }
    }
}
</script>

<style scoped>
.spone_block{
    font-weight: bold;
    font-size: 18px;
}
.grid-content{
    background-image: url('../../assets/images/bottom-bg1.jpg') ;
    background-size: cover;
    padding: 30px 2%;
    line-height: 18px;
    color: black;
    border-radius: 6px;
    width: 96%;
    text-align: center;
    }
 .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 100%;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/public/Bottom.vue